import React, { useContext, useEffect, useState } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";
import config from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { getSessionData } from "../../cache";

function Exregularsecond() {
  const Navigate = useNavigate();
  const {
    class9exregulardata,
    setClass9exregulardata,
    RegistrationNumber,
    sessionCode,
    modeex,
    setCandidateid,
    candidateid,
    setCastecode,
    castecode,
    setDivyangcode,
    divyangcode,
    setRegistrationNumber,
    setSessionCode,
  } = useContext(ContextBoard);
  const [loading, setLoading] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAllDataPresent, setIsAllDataPresent] = useState(false);
  const [casteList, setCasteList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);

  const [fieldsMissing, setFieldsMissing] = useState({
    fatherMissing: false,
    motherMissing: false,
    dobMissing: false,
    genderMissing: false,
  });

  useEffect(() => {
    const casteList = getSessionData("casteList") || [];
    const divyangList = getSessionData("divyangList") || [];

    setCasteList(casteList);
    setDivyangList(divyangList);
    setFieldsMissing({
      fatherMissing: !class9exregulardata.fatheR_NAME,
      motherMissing: !class9exregulardata.motheR_NAME,
      dobMissing: !(class9exregulardata.dob || class9exregulardata.doB_1),
      genderMissing: !class9exregulardata.gender,
    });
  }, [Navigate]);

  useEffect(() => {
    setIsAllDataPresent(
      !fieldsMissing.fatherMissing &&
        !fieldsMissing.motherMissing &&
        !fieldsMissing.dobMissing &&
        !fieldsMissing.genderMissing
    );
  }, [fieldsMissing]);

  useEffect(() => {
    const fetchDataIfEditMode = async () => {
      if (modeex === "edit") {
        setLoading(true);
        try {
          const token = sessionStorage.getItem("tokenclassix");
          const response = await fetch(
            `${config.API_BASE_URL}/CheckingDataEXRegularStudent_CL9`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                registratioN_NO: RegistrationNumber,
                SESSION_CODE: sessionCode,
              }),
            }
          );

          const result = await response.json();

          if (result.status === 200) {
            console.log("result", result);
            setClass9exregulardata(result.data.exRegularChecking_data);
            setLoading(false);
            setFieldsMissing({
              fatherMissing: !result.data.exRegularChecking_data.fatheR_NAME,
              motherMissing: !result.data.exRegularChecking_data.motheR_NAME,
              dobMissing: !(
                result.data.exRegularChecking_data.dob ||
                result.data.exRegularChecking_data.doB_1
              ),
              genderMissing: !result.data.exRegularChecking_data.gender,
            });
            // Navigate("/class-ix-add-ex-regular-student");
          } else {
            Navigate("/class-ix-ex-regular-student");
          }
        } catch (err) {
          setLoading(false);
          console.error(err);
          Navigate("/class-ix-ex-regular-student");
        }
      } else if (!class9exregulardata) {
        Navigate("/class-ix-ex-regular-student");
      }
    };

    fetchDataIfEditMode();
  }, []);
  const handlePreview = () => {
    const newErrors = {};
    const trimmed = (val) => (val || "").trim();
    const candidateName = trimmed(class9exregulardata.candidatE_NAME);
    const fathersName = trimmed(class9exregulardata.fatheR_NAME);
    const mothersName = trimmed(class9exregulardata.motheR_NAME);

    if (candidateName) {
      if (
        fathersName &&
        mothersName &&
        candidateName.toLowerCase() === fathersName.toLowerCase() &&
        candidateName.toLowerCase() === mothersName.toLowerCase()
      ) {
        newErrors.candidatE_NAME =
          "Candidate name cannot be the same as Father's and Mother's name.";
        newErrors.fatheR_NAME =
          "Father's name cannot be the same as Candidate and Mother's name.";
        newErrors.motheR_NAME =
          "Mother's name cannot be the same as Candidate and Father's name.";
        toast.error(
          "All names are the same! Candidate, Father's name, and Mother's name cannot be the same."
        );
      } else {
        if (
          fathersName &&
          candidateName.toLowerCase() === fathersName.toLowerCase()
        ) {
          newErrors.candidatE_NAME =
            "Candidate name cannot be the same as Father's name.";
          newErrors.fatheR_NAME =
            "Father's name cannot be the same as Candidate name.";
          toast.error(
            "Duplicate names! Candidate name cannot be the same as Father's name."
          );
        }
        if (
          mothersName &&
          candidateName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.candidatE_NAME =
            "Candidate name cannot be the same as Mother's name.";
          newErrors.motheR_NAME =
            "Mother's name cannot be the same as Candidate name.";
          toast.error(
            "Duplicate names! Candidate name cannot be the same as Mother's name."
          );
        }
        if (
          fathersName &&
          mothersName &&
          fathersName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.fatheR_NAME =
            "Father's name cannot be the same as Mother's name.";
          newErrors.motheR_NAME =
            "Mother's name cannot be the same as Father's name.";
          toast.error(
            "Duplicate names! Father's name cannot be the same as Mother's name."
          );
        }
      }
    }
    if (
      fieldsMissing.dobMissing &&
      !(class9exregulardata.dob || class9exregulardata.doB_1)
    ) {
      newErrors.dob = "Date of Birth is required.";
    }
    if (fieldsMissing.genderMissing && !class9exregulardata.gender) {
      newErrors.gender = "Gender is required.";
    }
    if (fieldsMissing.fatherMissing && !class9exregulardata.fatheR_NAME) {
      newErrors.fatheR_NAME = "Father Name is required.";
    }
    if (fieldsMissing.motherMissing && !class9exregulardata.motheR_NAME) {
      newErrors.motheR_NAME = "Mother Name is required.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setIsPreviewed(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Focus first error field if needed
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    }
  };
  const handleChange = (e) => {
    const { name, value = "" } = e.target;
    let formattedValue = value;

    if (name === "fatheR_NAME" || name === "motheR_NAME") {
      formattedValue = value
        .toUpperCase()
        .replace(/[^A-Z\s]/g, "")
        .slice(0, 35);
    }

    setClass9exregulardata((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };
  const formatDateForApi = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  };

  const handleChangeDate = (date) => {
    setClass9exregulardata((prev) => ({
      ...prev,
      dob: date ? formatDateForApi(date) : "",
    }));
  };

  const handleSubmit = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure to save it?",
      text: "Please check information before submitting!​",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, cancel",
    });

    if (result.isConfirmed) {
      setLoading(true);
      const token = sessionStorage.getItem("tokenclassix");
      const payload = {
        // schooL_CODE: class9exregulardata.SCHOOL_CODE || "",
        gender: class9exregulardata.gender?.toUpperCase() || "",
        candidatE_ID: class9exregulardata.candidatE_ID || "",
        candidatE_NAME: class9exregulardata.candidatE_NAME || "",
        dob: class9exregulardata.dob || "",
        fatheR_NAME: class9exregulardata.fatheR_NAME || "",
        motheR_NAME: class9exregulardata.motheR_NAME || "",
        religion: class9exregulardata.religion || "",
        nationality: "INDIAN",
        aadhaR_CARD: class9exregulardata.aadhaR_CARD || "",
        apaaR_ID: class9exregulardata.apaaR_ID || "",
        divyang: class9exregulardata.divyang || "",
        cast: class9exregulardata.cast || "",
        contacT_NO: class9exregulardata.contacT_NO || "",
        emaiL_ID: class9exregulardata.emaiL_ID || "",
        area: class9exregulardata.area || "",
        state: class9exregulardata.state || "",
        districT_ID: class9exregulardata.districT_ID || "",
        block: class9exregulardata.block || "",
        address: class9exregulardata.address || "",
        pincode: class9exregulardata.pincode || "",
        clasS_ROLL_NO: class9exregulardata.rolL_NO || "",
        mediuM_OF_EXAM: class9exregulardata.mediuM_OF_EXAM || "",
        section: "",
        subjecT_1: class9exregulardata.subjecT_1 || "",
        subjecT_2: class9exregulardata.subjecT_2 || "",
        subjecT_3: class9exregulardata.subjecT_3 || "",
        subjecT_4: class9exregulardata.subjecT_4 || "",
        subjecT_5: class9exregulardata.subjecT_5 || "",
        subjecT_6: class9exregulardata.subjecT_6 || "",
        boarD_NAME: "JAC",
        exaM_YEAR: class9exregulardata.exaM_YEAR || "",
        academiC_SESSION: class9exregulardata.sessioN_FULL_NAME || "",
        studenT_EXAM_SUB_CATEGORY:
          class9exregulardata.studenT_EXAM_SUB_CATEGORY || "",
        REGISTRATION_NO: class9exregulardata.registratioN_NO || "",
      };
      try {
        setLoading(true);
        const response = await fetch(
          `${config.API_BASE_URL}/InsertEXRegularStudentRegistrationCL9`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const data = await response.json();

        if (response.status === 200) {
          setLoading(false);
          setCandidateid(class9exregulardata.candidatE_ID);
          setCastecode(class9exregulardata.cast);
          setDivyangcode(class9exregulardata.divyang);
          setClass9exregulardata("");
          setLoading(false);
          Swal.fire("Saved!", "Your data has been saved.", "success").then(
            () => {
              Navigate("/class-ix-upload-document");
            }
          );
        } else {
          setLoading(false);
          Swal.fire(
            "Failed!",
            data?.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        Swal.fire("Error", "Failed to save data. Try again later.", "error");
      }
    }
  };
  const handlecontinue = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before proceeding to next.",
      });
      return;
    }

    setCandidateid(candidateid);
    setCastecode(castecode);
    setDivyangcode(divyangcode);
    setRegistrationNumber("");
    setSessionCode("");

    Navigate("/class-ix-upload-document");
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div class="container-scroller">
        <Navbar />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Add Ex-Regular
                      Student
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            Navigate("/class-ix-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 stretch-card mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="mb-0 p-2">
                        Registration / Previous Examination Details
                      </h5>
                    </div>
                    <div class="card-body">
                      <div
                        class="row d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div class="col-md-10 py-3">
                          <div class="row">
                            <label class="col-md-3">Examination Year :</label>
                            <div class="col-md-3">
                              <input
                                type="text"
                                disabled
                                class="form-control form-control-xs number"
                                value={class9exregulardata.exaM_YEAR || ""}
                              />
                            </div>
                            <label class="col-md-2">Roll Code :</label>
                            <div class="col-md-3">
                              <input
                                type="text"
                                disabled
                                class="form-control form-control-xs number"
                                value={class9exregulardata.schooL_CODE || ""}
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">
                              Registration Number :
                            </label>
                            <div class="col-md-3">
                              <input
                                type="text"
                                disabled
                                class="form-control form-control-xs number"
                                value={
                                  class9exregulardata.registratioN_NO || ""
                                }
                              />
                            </div>
                            <label class="col-md-2">Roll Number :</label>
                            <div class="col-md-3">
                              <input
                                type="text"
                                disabled
                                class="form-control form-control-xs number"
                                value={class9exregulardata.rolL_NO || ""}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-12"
                          style={{ borderRight: "0px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Name of Student </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    className={`form-control form-control-sm ${
                                      errors.candidatE_NAME ? "is-invalid" : ""
                                    }`}
                                    name="candidatE_NAME"
                                    maxlength="35"
                                    placeholder="Cadidate Name"
                                    value={
                                      class9exregulardata.candidatE_NAME || ""
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <select
                                  style={{ color: "#1f1f1f" }}
                                  value={
                                    class9exregulardata.gender?.toUpperCase() ||
                                    ""
                                  }
                                  name="gender"
                                  onChange={handleChange}
                                  className={`form-control form-control-sm ${
                                    errors.gender ? "is-invalid" : ""
                                  }`}
                                  disabled={
                                    !fieldsMissing.genderMissing || isPreviewed
                                  }
                                >
                                  <option value=""></option>
                                  <option value="MALE">MALE</option>
                                  <option value="FEMALE">FEMALE</option>
                                  <option value="TRANSGENDER">
                                    TRANSGENDER
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div className="form-group mb-3">
                                <label>Date of Birth</label>
                                <DatePicker
                                  name="dob"
                                  selected={(() => {
                                    const rawDob =
                                      class9exregulardata.dob ||
                                      class9exregulardata.doB_1 ||
                                      "";

                                    if (!rawDob) return null;

                                    const [dd, mm, yyyy] = rawDob.split("-");

                                    // ✓ Safe: creates a LOCAL date, no timezone shift
                                    return new Date(
                                      Number(yyyy),
                                      Number(mm) - 1,
                                      Number(dd)
                                    );
                                  })()}
                                  onChange={handleChangeDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={`form-control form-control-sm ${
                                    errors.dob ? "is-invalid" : ""
                                  }`}
                                  placeholderText="dd-mm-yyyy"
                                  disabled={
                                    !fieldsMissing.dobMissing || isPreviewed
                                  }
                                  onKeyDown={(e) => e.preventDefault()}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                              <div class="form-group  mb-3">
                                <label>Father’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="fatheR_NAME"
                                    disabled={
                                      !fieldsMissing.fatherMissing ||
                                      isPreviewed
                                    }
                                    onChange={handleChange}
                                    className={`form-control form-control-sm ${
                                      errors.fatheR_NAME ? "is-invalid" : ""
                                    }`}
                                    value={
                                      class9exregulardata.fatheR_NAME || ""
                                    }
                                    maxLength="35"
                                    placeholder="Father’s Name"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                              <div class="form-group  mb-3">
                                <label>Mother’s Name </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="motheR_NAME"
                                    disabled={
                                      !fieldsMissing.motherMissing ||
                                      isPreviewed
                                    }
                                    onChange={handleChange}
                                    className={`form-control form-control-sm ${
                                      errors.motheR_NAME ? "is-invalid" : ""
                                    }`}
                                    value={
                                      class9exregulardata.motheR_NAME || ""
                                    }
                                    maxlength="35"
                                    placeholder="Mother’s Name"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Religion</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={
                                    class9exregulardata.religioN_NAME || ""
                                  }
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Nationality</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value="INDIAN"
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Caste</label>
                                <select
                                  style={{ color: "#1f1f1f" }}
                                  className="form-control form-select-sm"
                                  name="caste_val"
                                  id="caste_val"
                                  value={class9exregulardata.cast || ""}
                                  onChange={handleChange}
                                  disabled
                                >
                                  <option value=""></option>
                                  {casteList.map((caste) => (
                                    <option
                                      key={caste.castE_ID}
                                      value={caste.castE_ID}
                                    >
                                      {caste.castE_NAME}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Area</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={class9exregulardata.area || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-12">
                              <div class="form-group mb-3">
                                <label>Divyang</label>
                                <select
                                  style={{ color: "#1f1f1f" }}
                                  className="form-control form-select-sm"
                                  id="divyang_val"
                                  name="divyang_val"
                                  value={class9exregulardata.divyang || ""}
                                  disabled
                                >
                                  <option value=""></option>
                                  {divyangList.map((divyang) => (
                                    <option
                                      key={divyang.divyanG_ID}
                                      value={divyang.divyanG_ID}
                                    >
                                      {divyang.divyanG_NAME}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-m-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice </label>
                                <input
                                  type="text"
                                  disabled
                                  className="form-control form-control-sm"
                                  value={
                                    class9exregulardata.studenT_EXAM_SUB_CATEGORY ||
                                    ""
                                  }
                                ></input>
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value="JAC"
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Medium of Examination </label>
                                <input
                                  disabled
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={class9exregulardata.mediuM_NAME || ""}
                                ></input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Language I Subject </label>
                                <input
                                  disabled
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    class9exregulardata.subjecT_NAME1
                                      ? class9exregulardata.subjecT_1
                                        ? `${class9exregulardata.subjecT_NAME1} (${class9exregulardata.subjecT_1})`
                                        : class9exregulardata.subjecT_NAME1
                                      : class9exregulardata.subjecT_1 || ""
                                  }
                                ></input>
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Language II Subject </label>
                                <input
                                  disabled
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    class9exregulardata.subjecT_NAME2
                                      ? class9exregulardata.subjecT_2
                                        ? `${class9exregulardata.subjecT_NAME2} (${class9exregulardata.subjecT_2})`
                                        : class9exregulardata.subjecT_NAME2
                                      : class9exregulardata.subjecT_2 || ""
                                  }
                                ></input>
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory I Subject </label>
                                <input
                                  disabled
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    class9exregulardata.subjecT_NAME3
                                      ? class9exregulardata.subjecT_3
                                        ? `${class9exregulardata.subjecT_NAME3} (${class9exregulardata.subjecT_3})`
                                        : class9exregulardata.subjecT_NAME3
                                      : class9exregulardata.subjecT_3 || ""
                                  }
                                ></input>
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory II Subject </label>
                                <input
                                  disabled
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    class9exregulardata.subjecT_NAME4
                                      ? class9exregulardata.subjecT_4
                                        ? `${class9exregulardata.subjecT_NAME4} (${class9exregulardata.subjecT_4})`
                                        : class9exregulardata.subjecT_NAME4
                                      : class9exregulardata.subjecT_4 || ""
                                  }
                                ></input>
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Compulsory III Subject </label>
                                <input
                                  disabled
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={
                                    class9exregulardata.subjecT_NAME5
                                      ? class9exregulardata.subjecT_5
                                        ? `${class9exregulardata.subjecT_NAME5} (${class9exregulardata.subjecT_5})`
                                        : class9exregulardata.subjecT_NAME5
                                      : class9exregulardata.subjecT_5 || ""
                                  }
                                ></input>
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Additional subject </label>
                                <input
                                  type="text"
                                  disabled
                                  className="form-control form-control-sm"
                                  value={
                                    class9exregulardata.subjecT_NAME6
                                      ? class9exregulardata.subjecT_6
                                        ? `${class9exregulardata.subjecT_NAME6} (${class9exregulardata.subjecT_6})`
                                        : class9exregulardata.subjecT_NAME6
                                      : class9exregulardata.subjecT_6 || ""
                                  }
                                ></input>
                              </div>
                            </div>
                            <div
                              class="col-lg-4 col-m-4"
                              id="Registration-Session"
                            >
                              <div class="form-group mb-3">
                                <label>Registration Session </label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  value={
                                    class9exregulardata.sessioN_FULL_NAME || ""
                                  }
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <h5 style={{ color: "red" }}>
                            <input
                              type="checkbox"
                              checked={isAgreed}
                              onChange={(e) => setIsAgreed(e.target.checked)}
                            />{" "}
                            I AGREE THAT ALL THE INFORMATION ABOVE IS CORRECT AS
                            PER MY BEST KNOWLEDGE.
                          </h5>
                        </div>

                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {modeex === "edit" ? (
                            // If in edit mode: only show Next button
                            <button
                              type="button"
                              onClick={handlecontinue}
                              className="btn btn-success"
                            >
                              Next <i className="fa fa-arrow-right me-1"></i>
                            </button>
                          ) : isAllDataPresent ? (
                            // All data present: only show Submit button
                            <button
                              onClick={handleSubmit}
                              type="button"
                              className="btn btn-primary pull-right"
                            >
                              <i className="fa fa-save me-1"></i> Submit
                            </button>
                          ) : isPreviewed ? (
                            // After preview: show Edit + Submit buttons
                            <>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-warning me-2"
                              >
                                Edit <i className="fa fa-edit me-1"></i>
                              </button>
                              <button
                                onClick={handleSubmit}
                                type="button"
                                className="btn btn-success"
                              >
                                Submit
                              </button>
                            </>
                          ) : (
                            // If missing fields and preview not clicked: show Preview button
                            <button
                              onClick={handlePreview}
                              type="button"
                              className="btn btn-primary pull-right"
                            >
                              <i className="fa fa-save me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Exregularsecond;
